import { Flair } from '@creator/sdk/modules/flair/flair.model';
import { getToken } from '../token/helpers';

export function getTokenFlairs(tokenName: string): Flair[] {
    const token = getToken(tokenName);
    const flairs = token ? token.activeFlairs : [] as Flair[];
    return flairs;
}